import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class MaximumLengthValidationRule extends ValidationRule {
  private maximum: number;

  constructor(maximum: number, key: string | null = null) {
    if (!key) {
      key = ValidationTypes.maximumLength;
    }

    super(key);
    this.maximum = maximum;
  }

  isValid(value: any): boolean {
    if (!value) {
      return true;
    }

    return value.length <= this.maximum;
  }
}
